/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * How the multiplier is delivered to the user
 * @export
 */
export const StreakMultiplierMode = {
    AURA: 'AURA',
    CONSUMABLE: 'CONSUMABLE'
} as const;
export type StreakMultiplierMode = typeof StreakMultiplierMode[keyof typeof StreakMultiplierMode];


export function instanceOfStreakMultiplierMode(value: any): boolean {
    for (const key in StreakMultiplierMode) {
        if (Object.prototype.hasOwnProperty.call(StreakMultiplierMode, key)) {
            if (StreakMultiplierMode[key as keyof typeof StreakMultiplierMode] === value) {
                return true;
            }
        }
    }
    return false;
}

export function StreakMultiplierModeFromJSON(json: any): StreakMultiplierMode {
    return StreakMultiplierModeFromJSONTyped(json, false);
}

export function StreakMultiplierModeFromJSONTyped(json: any, ignoreDiscriminator: boolean): StreakMultiplierMode {
    return json as StreakMultiplierMode;
}

export function StreakMultiplierModeToJSON(value?: StreakMultiplierMode | null): any {
    return value as any;
}

export function StreakMultiplierModeToJSONTyped(value: any, ignoreDiscriminator: boolean): StreakMultiplierMode {
    return value as StreakMultiplierMode;
}

